// utils/refundCalculations.js
export const getAddonTotalPrice = (addon) => {
  if (!addon || typeof addon !== "object") return 0;
  let price = parseFloat(addon.totalPrice || 0);
  if (addon.options && Array.isArray(addon.options)) {
    addon.options.forEach((option) => {
      price += parseFloat(option.totalPrice || 0);
      if (option.subOptions && Array.isArray(option.subOptions)) {
        option.subOptions.forEach((sub) => {
          price += parseFloat(sub.totalPrice || 0);
        });
      }
    });
  }
  return price;
};

export const getRefundableAddonPrices = (addons, selectedAddonsIds) => {
  if (!addons || !Array.isArray(addons)) return 0;
  return addons
    .filter((ad) => ad.refundStatus !== "Refunded")
    .filter((ad) => selectedAddonsIds.includes(ad.id))
    .reduce((sum, ad) => sum + getAddonTotalPrice(ad), 0);
};

export const getRefundableItemPrices = (item, refundQty, order) => {
  const unitPrice =
    parseFloat(item.basePrice || 0) +
    parseFloat(item.vatInAmount || 0) +
    parseFloat(item.sdInAmount || 0);
  const itemPrice = unitPrice * refundQty;
  const totalItemPrice = parseFloat(order.totalItemPrice || 0);
  const totalTips = parseFloat(order.totalTips || 0);
  const totalSC = parseFloat(order.totalServiceCharge || 0);
  const totalSCVat = parseFloat(order.totalServiceChargeVat || 0);
  // const itemTips =
  //   totalItemPrice > 0 ? (itemPrice / totalItemPrice) * totalTips : 0;
  // const itemSC =
  //   totalItemPrice > 0 ? (itemPrice / totalItemPrice) * totalSC : 0;
  // const itemSCVat =
  //   totalItemPrice > 0 ? (itemPrice / totalItemPrice) * totalSCVat : 0;

  const itemMisedTips = item.tips != 0 ? item.remainingTips / item.qty : 0;
  const itemMisedSC =
    item.serviceCharge != 0 ? item.remainingServiceCharge / item.qty : 0;
  const itemMisedSCVat =
    item.serviceChargeVat != 0 ? item.remainingServiceChargeVAT / item.qty : 0;

  const itemTips =
    item.qty == refundQty ? item.remainingTips : itemMisedTips * refundQty;
  const itemSC =
    item.qty == refundQty
      ? item.remainingServiceCharge
      : itemMisedSC * refundQty;
  const itemSCVat =
    item.qty == refundQty
      ? item.remainingServiceChargeVAT
      : itemMisedSCVat * refundQty;

  return { itemPrice, itemTips, itemSC, itemSCVat };
};

export const getRefundableAddonAmounts = (
  addonPrices,
  order,
  selectedAddons,
  itemAddons
) => {
  const totalItemPrice = parseFloat(order.totalItemPrice || 0);
  const totalTips = parseFloat(order.totalTips || 0);
  const totalSC = parseFloat(order.totalServiceCharge || 0);
  const totalSCVat = parseFloat(order.totalServiceChargeVat || 0);

  console.log("Khalid selectedAddons", selectedAddons);
  console.log("Khalid itemAddons", itemAddons);
  console.log("Khalid addonPrices", addonPrices);
  const addonTips = selectedAddons
    .filter((x) => x.remainingTips > 0)
    .reduce((sum, x) => sum + x.remainingTips, 0);
  const addonSC = selectedAddons
    .filter((x) => x.remainingServiceCharge > 0)
    .reduce((sum, x) => sum + x.remainingServiceCharge, 0);
  const addonSCVat = selectedAddons
    .filter((x) => x.remainingServiceChargeVAT > 0)
    .reduce((sum, x) => sum + x.remainingServiceChargeVAT, 0);
  //totalItemPrice > 0 ? (addonPrices / totalItemPrice) * totalSCVat : 0;
  return { addonTips, addonSC, addonSCVat };
};

export const getRefundTotalForItem = (
  item,
  refundQty,
  selectedAddons,
  order
) => {
  const { itemPrice, itemTips, itemSC, itemSCVat } = getRefundableItemPrices(
    item,
    refundQty,
    order
  );

  const selectedAddonsIds = selectedAddons.map((a) => a.id);
  const addonPrices = getRefundableAddonPrices(
    item.addons || [],
    selectedAddonsIds
  );
  const { addonTips, addonSC, addonSCVat } = getRefundableAddonAmounts(
    addonPrices,
    order,
    selectedAddons,
    item.addons
  );
  const total =
    itemPrice +
    itemTips +
    itemSC +
    itemSCVat +
    addonPrices +
    addonTips +
    addonSC +
    addonSCVat;
  return {
    itemPrice,
    itemTips,
    itemSC,
    itemSCVat,
    addonPrices,
    addonTips,
    addonSC,
    addonSCVat,
    total,
  };
};

export const calculateTotalRefundAmount = (
  items,
  order,
  getRefundQty,
  getSelectedAddons
) => {
  return items.reduce((total, item) => {
    const refundQty = getRefundQty(item);
    const selectedAddons = getSelectedAddons(item);
    const { total: itemTotal } = getRefundTotalForItem(
      item,
      refundQty,
      selectedAddons,
      order
    );
    return total + itemTotal;
  }, 0);
};
